import { DragEndEvent } from "@dnd-kit/core";
import { MessagePartInputExtended } from "@/pages/BulkMessaging/types";

interface UseDragAndDropProps {
  messageParts: MessagePartInputExtended[];
  onChange: (messageParts: MessagePartInputExtended[]) => void;
}

export const useDragAndDrop = ({
  messageParts,
  onChange,
}: UseDragAndDropProps) => {
  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      const oldIndex = parseInt(active.id as string);
      const newIndex = parseInt(over.id as string);

      const newMessageParts = [...messageParts];
      const [movedItem] = newMessageParts.splice(oldIndex, 1);
      newMessageParts.splice(newIndex, 0, movedItem);

      onChange(newMessageParts);
    }
  };

  return { handleDragEnd };
};
